module.exports = __webpack_public_path__ + "static/media/sz.fa23d5aa.svg";